import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { withRouter } from 'react-router';
import { getTasksResources } from 'HELPERS/resources';
import './ControlPage.less';

class ControlPageSidebar extends Component {
  constructor(props) {
    super(props);

    const parts = this.props.location.pathname.split('/');
    const last = parts.pop();

    this.state = {
      current: last,
    };
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location && location.pathname !== prevProps.location.pathname) {
      if (location.state) {
        this.setMenuState(location.state.current);
      }
    }
  }

  setMenuState = (current) => {
    if (current) {
      this.setState({ current });
    }
  };

  handleClick = (e) => {
    this.setState({
      current: e.key,
    }, () => {
      this.props.history.push(`/control/${e.key}`);
    });
  };

  render() {
    const resources = getTasksResources();
    return (
      <div className="side-navigation">
        <Menu
          onClick={this.handleClick}
          selectedKeys={[this.state.current]}
          className="task-navigation"
        >
          <Menu.Item id="schedule-date" key="schedule-date">
            Newsletter day
          </Menu.Item>
          {Object.keys(resources).map(resourceKey => (
            <Menu.Item
              id={resources[resourceKey].permalink}
              key={resources[resourceKey].permalink}
            >
              {resources[resourceKey].title}
            </Menu.Item>
          ))}
        </Menu>
      </div>
    );
  }
}

ControlPageSidebar.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export { ControlPageSidebar as PureControlPageSidebar };

export default withRouter(ControlPageSidebar);



// WEBPACK FOOTER //
// ./src/pages/Control/ControlPageSidebar.js